import React from 'react';
import MapData from '../map/map-data';
import { HEALTH_REPORT_URL } from '../../services/config';
import { Table, Button } from 'reactstrap';
import InspectModal from './inspect-modal';

class Inspector extends React.Component {

  mapData = new MapData(HEALTH_REPORT_URL, true);

  state = {
    data: null,
    inspectProductInstance: null
  };

  componentDidMount() {
    this.mapData.on('data', data => this.setState({ data }));

    this.mapData.start()
      .catch((error) => {
        console.error('Error starting map data fetcher');
        console.error(error);
      })
  }

  componentWillUnmount() {
    this.mapData.cancel()
      .catch((error) => {
        console.error('Error cancelling map data fetcher');
        console.error(error);
      })
  }

  onInspectProduct(productInstance) {
    return () => {
      this.setState({
        inspectProductInstance: productInstance
      });
    }
  }

  onCancelInspection = () => {
    this.setState({
      inspectProductInstance: null
    })
  };

  render() {
    const data = (this.state.data || [])
      .filter(item => item.uuid)
      .reduce(
        (array, location) => {
          return array
            .concat(
              location
                .products
                .filter(product => product.productId === 'com.rewardsinc:site-controller-app')
                .map(product => ({
                  ...product,
                  status: product.overallStatus || location.status || (product.status || [])[0],
                  locationName: location.locationName,
                  customerName: location.customerName
                }))
            )
        },
        []
      )
      .sort(
        (a, b) => {
          if (a.customerName != b.customerName) {
            return a.customerName < b.customerName ? -1 : 1;
          }
          return a.locationName < b.locationName ? -1 : 1;
        }
      );
    return (
      <div>
        <Table borderless hover striped>
          <thead>
          <tr>
            <th>Status</th>
            <th>Location</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {
            !this.state.data ? (
                <tr>
                  <td colSpan="3">Loading...</td>
                </tr>
              ) : null
          }
          {
            this.state.data ? (
                data.length ? (
                    data
                      .map(
                        (item, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-center">
                                <div
                                  style={{
                                    width: 25,
                                    height: 25,
                                    display: 'block',
                                    borderRadius: '100%',
                                    backgroundColor: item.status.status.color
                                  }}
                                />
                              </td>
                              <td>
                                {item.customerName}{item.locationName ? ` - ${item.locationName}` : ''}<br/>
                                <span className="text-muted">{item.uuid}</span>
                              </td>
                              <td>
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={this.onInspectProduct(item)}
                                >
                                  Inspect
                                </Button>
                              </td>
                            </tr>
                          );
                        }
                      )
                  ) : (
                    <tr>
                      <td colSpan="3">No data found</td>
                    </tr>
                  )
              ) : null
          }
          </tbody>
        </Table>
        {
          this.state.inspectProductInstance ? (
            <InspectModal isOpen={true} onToggle={this.onCancelInspection} productInstance={this.state.inspectProductInstance} />
          ) : null
        }
      </div>
    )
  }
}

export default Inspector;


// WEBPACK FOOTER //
// ./src/app/inspector/index.js